import client, {handleError} from "../utils/client";
import env from "../env";

export const getAnnouncementsRequest = () => {
    return client.get(`${env.apiUrl}/api/announcements`).catch(handleError);
}

export const confirmAnnouncementRequest = (id)=> {
    return client.put(`${env.apiUrl}/api/announcements/${id}/confirm`).catch(handleError);
}